import type { GeneratedDelivery, GenerationProgress } from "./lod-generation";
import { type LodGenerationOptions, validateLodGenerationOptions } from "./lod-generation-options";

export function startLodGeneration(
	url: string,
	filename: string,
	onProgress: (value: GenerationProgress) => void,
	options?: LodGenerationOptions,
) {
	const optionsError = validateLodGenerationOptions(options);
	if (optionsError) throw new Error(optionsError);
	const settings = options?.levelRatios === undefined ? undefined : { levelRatios: [...options.levelRatios] };
	const jobId = crypto.randomUUID();
	const worker = new Worker(new URL("../workers/lod-generation.worker.ts", import.meta.url), { type: "module" });
	let rejectJob: (reason: Error) => void = () => {};
	const cleanup = async () => {
		worker.terminate();
		try {
			await (await navigator.storage.getDirectory()).removeEntry(`gsplat-lod-${jobId}`, { recursive: true });
		} catch {
			/* Already cleaned or unavailable. */
		}
	};
	const result = new Promise<GeneratedDelivery>((resolve, reject) => {
		rejectJob = reject;
		worker.onmessage = event => {
			const message = event.data;
			if (message.type === "progress") onProgress(message.progress);
			if (message.type === "complete") {
				void cleanup();
				resolve(message.delivery);
			}
			if (message.type === "error") {
				void cleanup();
				reject(new Error(message.error));
			}
		};
		worker.onerror = event => {
			void cleanup();
			reject(new Error(event.message || "LOD generation could not start."));
		};
		worker.postMessage({ url, filename, jobId, options: settings });
	});
	return {
		result,
		cancel() {
			void cleanup();
			rejectJob(new DOMException("Generation cancelled", "AbortError"));
		},
	};
}
